import React, { useEffect, useId, useState } from 'react';
import Button3D from '../ui/Button3D';
import { supabaseClient } from '../../config/supabase';
import { useSaveToast } from '../ui/SaveToast';

export default function TripChangeSettings({ orgId, client = supabaseClient }) {
    const id = useId();
    const toast = useSaveToast();
    const [hours, setHours] = useState('2');
    const [message, setMessage] = useState('Please call us');
    const [busy, setBusy] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        if (!orgId) { setBusy(false); return () => { active = false; }; }
        (async () => {
            try {
                const { data, error: failure } = await client.from('org_trip_change_settings').select('cutoff_hours,cutoff_message').eq('org_id', orgId).maybeSingle();
                if (failure) throw failure;
                if (active) { setHours(String(data?.cutoff_hours ?? 2)); setMessage(data?.cutoff_message ?? 'Please call us'); }
            } catch (failure) { if (active) setError(failure.message); }
            finally { if (active) setBusy(false); }
        })();
        return () => { active = false; };
    }, [client, orgId]);
    async function save(event) {
        event.preventDefault();
        const cutoff = Number(hours);
        if (!hours.trim() || !Number.isFinite(cutoff) || cutoff < 0 || cutoff > 720 || !message.trim()) {
            setError('Choose a cutoff from 0 to 720 hours and enter a message.'); return;
        }
        setBusy(true); setError('');
        try {
            const { error: failure } = await client.from('org_trip_change_settings').upsert({ org_id: orgId, cutoff_hours: cutoff, cutoff_message: message.trim() }, { onConflict: 'org_id' });
            if (failure) throw failure;
            toast.saved();
        } catch (failure) { setError(failure.message); toast.failed(failure.message); }
        finally { setBusy(false); }
    }
    return <section className="text-[var(--ink)] space-y-3" aria-labelledby={`${id}-title`}>
        <h2 id={`${id}-title`} className="text-lg font-semibold">Client trip change requests</h2>
        <p>Clients can request a new pickup time or cancellation before the cutoff. Staff review every request.</p>
        {error && <p role="alert">{error}</p>}
        <form onSubmit={save}><fieldset disabled={busy || !orgId} className="space-y-3">
            <label className="block" htmlFor={`${id}-hours`}>Request cutoff (hours before pickup)</label>
            <input id={`${id}-hours`} type="number" min="0" max="720" step="0.25" required value={hours} onChange={(e) => setHours(e.target.value)} className="min-h-[44px] border rounded-lg p-2 bg-[var(--surface-raised)]" />
            <label className="block" htmlFor={`${id}-message`}>Message inside the cutoff</label>
            <input id={`${id}-message`} required maxLength={500} value={message} onChange={(e) => setMessage(e.target.value)} className="w-full min-h-[44px] border rounded-lg p-2 bg-[var(--surface-raised)]" />
            <Button3D type="submit" className="min-h-[44px]" style={{ minHeight: 44 }}>Save request settings</Button3D>
        </fieldset></form>
    </section>;
}
